



































import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MissionShareIcon',
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
})
